import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useSeo } from "../hooks/useSeo";
import { exhibitionStatus } from "../utils/dates";
import { ExhibitionArchCard } from "../components/ExhibitionArchCard";
import { Reveal } from "../components/motion/Reveal";

const FILTERS = [
  { key: "all", label: "All" },
  { key: "current", label: "Now and Upcoming" },
  { key: "past", label: "Past" },
];

const matches = (ex, filter) => {
  const status = exhibitionStatus(ex.start_date, ex.end_date);
  if (filter === "current") return status === "NOW SHOWING" || status === "UPCOMING";
  if (filter === "past") return status === "PAST";
  return true;
};

export default function ExhibitionsPage() {
  const [exhibitions, setExhibitions] = useState([]);
  const [filter, setFilter] = useState("all");

  useSeo({
    title: "Exhibitions | Pantheon Art",
    description: "Past, current and upcoming exhibitions managed by Pantheon Art.",
    path: "/exhibitions",
  });

  useEffect(() => {
    api
      .get("/exhibitions")
      .then((res) => {
        const sorted = [...(res.data || [])].sort(
          (a, b) => new Date(b.start_date || 0) - new Date(a.start_date || 0)
        );
        setExhibitions(sorted);
      })
      .catch(() => {});
  }, []);

  const visible = exhibitions.filter((ex) => matches(ex, filter));

  return (
    <div className="px-5 pb-24 pt-32 lg:px-10 lg:pt-40" data-testid="exhibitions-page">
      <Reveal>
        <p className="eyebrow mb-4">Archive</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h1 className="h-condensed text-[clamp(3rem,8vw,7rem)]">Exhibitions</h1>
      </Reveal>

      <nav className="mt-10 flex flex-wrap gap-6" aria-label="Filter exhibitions">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            type="button"
            data-testid={`filter-${f.key}`}
            onClick={() => setFilter(f.key)}
            aria-pressed={filter === f.key}
            className={`link-arrow text-xs ${filter === f.key ? "opacity-100" : "opacity-50"}`}
          >
            {f.label}
          </button>
        ))}
      </nav>

      <div className="hairline-t mt-10 grid gap-x-8 gap-y-16 pt-12 sm:grid-cols-2 lg:grid-cols-3">
        {visible.map((ex, i) => (
          <Reveal key={ex.id || ex.slug} delay={(i % 3) * 0.1}>
            <ExhibitionArchCard exhibition={ex} showMeta />
          </Reveal>
        ))}
      </div>
      {visible.length === 0 && (
        <p className="body-text mt-16" data-testid="exhibitions-empty">
          No exhibitions in this view yet.
        </p>
      )}
    </div>
  );
}
